import { render, staticRenderFns } from "./com_data_radio.vue?vue&type=template&id=6fc36702&scoped=true&"
import script from "./com_data_radio.vue?vue&type=script&lang=js&"
export * from "./com_data_radio.vue?vue&type=script&lang=js&"
import style0 from "./com_data_radio.vue?vue&type=style&index=0&id=6fc36702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc36702",
  null
  
)

export default component.exports